import Icon from '../components/Icon.vue'

Icon.register({"sitemap":{"width":640,"height":512,"paths":[{"d":"M616 320H568V272C568 249.9 550.1 232 528 232H344V192H392C405.3 192 416 181.3 416 168V24C416 10.7 405.3 0 392 0H248C234.7 0 224 10.7 224 24V168C224 181.3 234.7 192 248 192H296V232H112C89.9 232 72 249.9 72 272V320H24C10.7 320 0 330.7 0 344V488C0 501.3 10.7 512 24 512H168C181.3 512 192 501.3 192 488V344C192 330.7 181.3 320 168 320H120V280H296V320H248C234.7 320 224 330.7 224 344V488C224 501.3 234.7 512 248 512H392C405.3 512 416 501.3 416 488V344C416 330.7 405.3 320 392 320H344V280H520V320H472C458.7 320 448 330.7 448 344V488C448 501.3 458.7 512 472 512H616C629.3 512 640 501.3 640 488V344C640 330.7 629.3 320 616 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/sitemap.js
// module id = null
// module chunks = 